import { Component, EventEmitter, Injector, Input, Output, ViewChild } from "@angular/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { Sended } from "../../models/mail-sender/sended";
import { RequestEmailsService } from "../../services/request-emails.service";
import { Attachment } from "../../models/attachment";
import { NgModel } from "@angular/forms";

@Component({
    selector: 'mail-sender',
    templateUrl: './mail-sender.component.html',
    styleUrls: [
        './mail-sender.component.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})

export class MailSender {
    @ViewChild("email1") emailModel: NgModel;
    
    @Input() requestId: number;
    @Input() email: string;
    @Input() fileId: number;
    @Input() attachment: Attachment;
    @Output() mailSended: EventEmitter<Sended> = new EventEmitter();

    constructor(private injector: Injector,
        private requestEmailsService: RequestEmailsService
    ) 
    {}

    sendFile(): void {
        this.requestEmailsService.send(this.requestId, "Документ", "", [this.email], [this.attachment]).subscribe(res => {
            if (res.isSuccessful) {
                if (this.mailSended) {
                    this.mailSended.emit(new Sended(res.isSuccessful, "Сообщение успешно отправлено"));
                }
            }
        
            this.closeDialog();
        });
    }

    cancel(): void {
        this.closeDialog();
    }

    closeDialog(): void {
        var dialog = this.injector.get(DialogRef);
        dialog.close();
    }

    get sendingDisabled(): boolean {
        return this.emailModel.invalid;
    }
}